import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/layout/Layout';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AdminLayout from './components/admin/AdminLayout';
import './styles/rich-text.css';
import Home from './pages/Home';
import Research from './pages/Research';
import ResearchAchievements from './pages/ResearchAchievements';
import ResearchDetail from './pages/ResearchDetail';
import Members from './pages/Members';
import News from './pages/News';
import NewsDetail from './pages/NewsDetail';
import Recruitment from './pages/Recruitment';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Profile from './pages/Profile';
import RepresentativePaperDetail from './pages/RepresentativePaperDetail';
import MemberDetail from './pages/MemberDetail';
import MemberManagement from './pages/admin/MemberManagement';
import NewsManagement from './pages/admin/NewsManagement';
import PublicationManagement from './pages/admin/PublicationManagement';
import ResearchManagement from './pages/admin/ResearchManagement';
import TeamActivityManagement from './pages/admin/TeamActivityManagement';
import ContactMessageManagement from './pages/admin/ContactMessageManagement';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <Routes>
          {/* 公开路由 */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          
          {/* 需要布局的路由 */}
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/research" element={<Layout><Research /></Layout>} />
          <Route path="/research-achievements" element={<Layout><ResearchAchievements /></Layout>} />
          <Route path="/research-achievements/:id" element={<Layout><ResearchDetail /></Layout>} />
          <Route path="/members" element={<Layout><Members /></Layout>} />
          <Route path="/news" element={<Layout><News /></Layout>} />
          <Route path="/news/:id" element={<Layout><NewsDetail /></Layout>} />
          <Route path="/recruitment" element={<Layout><Recruitment /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          <Route path="/members/:id" element={<Layout><MemberDetail /></Layout>} />
          <Route path="/representative-paper/:id" element={<Layout><RepresentativePaperDetail /></Layout>} />
          
          {/* 受保护的路由 */}
          <Route 
            path="/profile" 
            element={
              <ProtectedRoute>
                <Layout>
                  <Profile />
                </Layout>
              </ProtectedRoute>
            } 
          />
          
          {/* 管理后台路由 */}
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminLayout />
              </ProtectedRoute>
            } 
          >
            <Route index element={<NewsManagement />} />
            <Route path="news" element={<NewsManagement />} />
            <Route path="publications" element={<PublicationManagement />} />
            <Route path="members" element={<MemberManagement />} />
                          <Route path="team-activities" element={<TeamActivityManagement />} />
            <Route path="contact-messages" element={<ContactMessageManagement />} />
            <Route path="research" element={<ResearchManagement />} />
          </Route>
          
          <Route 
            path="/admin/members" 
            element={
              <ProtectedRoute requiredRole="admin">
                <Layout>
                  <MemberManagement />
                </Layout>
              </ProtectedRoute>
            } 
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App; 